// App constants - Industry-agnostic branding
export const APP_NAME = "Business Pal";
export const APP_TAGLINE = "Smart scheduling for modern businesses";
export const PUBLISHED_URL = "https://businesspal.tech";
export const BUSINESS_BASE_DOMAIN = "businesspal.tech";

// Officially recognised alternate domains (used in legal pages, SEO, contact info)
export const ALTERNATE_DOMAINS = [
  "businesspaltech.com",
  "www.businesspaltech.com",
] as const;

export const ALL_OFFICIAL_DOMAINS = [
  "businesspal.tech",
  "www.businesspal.tech",
  ...ALTERNATE_DOMAINS,
] as const;

// Days of week mapping
export const DAYS_OF_WEEK = [
  "monday",
  "tuesday", 
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const;

export type DayOfWeek = typeof DAYS_OF_WEEK[number];

// Booking statuses
export const BOOKING_STATUSES = {
  pending: { label: "Pending", color: "warning" },
  confirmed: { label: "Confirmed", color: "primary" },
  completed: { label: "Completed", color: "success" },
  cancelled: { label: "Cancelled", color: "muted" },
  no_show: { label: "No Show", color: "destructive" },
} as const;

// User roles - Industry-agnostic
// Note: Database enum values are 'staff' and 'business_admin'
export const USER_ROLES = {
  super_admin: { label: "Platform Admin", description: "Platform owner" },
  saas_manager: { label: "Support Admin", description: "Platform support" },
  business_admin: { label: "Business Admin", description: "Business manager" },
  staff: { label: "Staff", description: "Team member" },
  customer: { label: "Customer", description: "Client" },
} as const;

export type AppRole = keyof typeof USER_ROLES;

// Time slots configuration
export const TIME_SLOT_INTERVAL = 15; // minutes
export const DEFAULT_SERVICE_DURATION = 30; // minutes
export const BUSINESS_HOURS = {
  start: "09:00",
  end: "19:00",
} as const;
